import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import axiosInstance from "../../API/Axios/AxiosConfig";
import URLS from "../../API/Axios/URLS";
import {toast} from "react-toastify";

const initialState = {
    likedComments: [],
    isFirstLoad: false,
}

export const LIKED_COMMENT_ACTIONS = {
    UPDATE_LIKED_LIST: "UPDATE_LIKED_LIST",
}


const LikedReducer = (state = initialState, action) => {
    switch (action.type) {
        case LIKED_COMMENT_ACTIONS.UPDATE_LIKED_LIST:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
}


export function useLikedComments() {
    const dispatch = useDispatch();
    const state = useSelector(state => state.LikedReducer);
    const [isLoading, setIsLoading] = useState(false);

    function getLikedComments() {
        if (isLoading) return;
        axiosInstance.get(URLS.GetAllLikedComments).then((res) => {
            dispatch({
                type: LIKED_COMMENT_ACTIONS.UPDATE_LIKED_LIST,
                payload: {
                    likedComments: res.data?.data,
                    isFirstLoad: true,
                },
            })
        }).catch((err) => {

        }).finally(() => {
            setIsLoading(false);
        })
    }

    useEffect(() => {
        if (state.isFirstLoad) return;
        getLikedComments();

    }, []);

    function isCommentLiked(commentId) {
        return state.likedComments.includes(commentId);
    }
    const likeDislikeComment = (commentId) => {
        return new Promise((resolve, reject) => {
            toast.promise(axiosInstance.get(URLS.LikeDislikeComment+commentId ), {
                pending: "Loading...",
                success:isCommentLiked(commentId)?"Like removed":"Comment Liked",
                error: "Something went wrong",
            },{
                hideProgressBar:false,
                toastId:"like-dislike-comment"
            }).then( (res) => {
                dispatch({
                    type: LIKED_COMMENT_ACTIONS.UPDATE_LIKED_LIST,
                    payload: {
                        likedComments: res.data?.data?.likedCommentId,
                        isFirstLoad: true,
                    },
                })
                resolve(res.data?.data?.totalLikes);
            }).catch((err) => {
                reject(err);
            })
        })
    };

    const actions = {
        getLikedComments: getLikedComments,
        isCommentLiked: isCommentLiked,
        likeDislikeComment: likeDislikeComment,

    }



    return {
        likedListState: state,
        likedListActions: actions,
        isLikeListLoading: isLoading,

    }
}


export default LikedReducer;